<template>
  <div class="container">
    <div class="row">
      <div class="col">
        <h3 class="text-center">
          <span style="padding: 0 12px;border-left:1px solid;border-right:1px solid;">{{ $t('academy.title') }}</span>
        </h3>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <b-breadcrumb style="background-color: transparent;">
          <b-breadcrumb-item :to="{ name: 'index' }">{{ $t('index.title') }}</b-breadcrumb-item>
          <b-breadcrumb-item :to="{ name: 'college', params: { id: collegeId } }">{{ $t('academy.title') }}</b-breadcrumb-item>
          <b-breadcrumb-item active>{{ $t('college-registration-form.title') }}</b-breadcrumb-item>
        </b-breadcrumb>
      </div>
    </div>
    <div class="row" v-if="college">
      <div class="col">
        <div class="mb-4">
          <h4>{{ college.name }} - {{ $t('college-registration-form.title') }}</h4>
          <p class="text-muted" v-if="college.spkdate">
            {{ $t('academy.detail.admission-brochure.label.start-date') }}：{{ college.spkdate.slice(0, 10) }}
          </p>
        </div>
        <hr>
        <college-registration-form
          :college-id="college.id"
          :departments="departments"
        ></college-registration-form>
      </div>
    </div>
    <div v-else-if="loading" class="text-center py-5">
      <b-spinner label="Loading..."></b-spinner>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import { BreadcrumbPlugin, SpinnerPlugin } from 'bootstrap-vue'
import CollegeRegistrationForm from '@/components/forms/CollegeRegistrationForm'
import CollegeApiService from '@/services/budaedu-api-services/college-api-service.js'
import i18n from '@/plugins/i18n.js'

Vue.use(BreadcrumbPlugin)
Vue.use(SpinnerPlugin)
Vue.use(CollegeApiService)

export default {
  i18n,
  name: 'college-registration',
  props: {
    id: {
      type: [Number, String],
      required: true
    }
  },
  data() {
    return {
      college: null,
      departments: [],
      loading: true
    }
  },
  computed: {
    college_id() {
      return parseInt(this.id)
    }
  },
  methods: {
    async fetchCollegeData() {
      this.loading = true
      try {
        const response = await this.$collegeApiService.getById(this.college_id, 'include=departments')
        if (response && response.data) {
          this.college = response.data
          this.departments = response.data.departments || []
        }
      } catch (error) {
        console.error('Failed to fetch college data:', error)
      } finally {
        this.loading = false
      }
    }
  },
  async created() {
    await this.fetchCollegeData()
  },
  components: {
    CollegeRegistrationForm
  },
  metaInfo() {
    const title = this.$t('college-registration-form.title')
    const college_name = this.college ? ` - ${this.college.name}` : ''
    return {
      title: `${title}${college_name}`,
      meta: [{
        vmid: 'description',
        name: 'description',
        content: ''
      }]
    }
  }
}
</script>
